import React from "react";
import OverlayWrapper from "../OverlayWrapper";

export default function TournamentsSelectionsPopup(props) {
    return (
        <OverlayWrapper id="xs-tournaments-selections-overlay">
            <div className="xs_settingsMenu z-30 absolute container top-0 left-0 right-0 bottom-0">
                <div className="customPopup">
                    <div className="customPopup__content">
                        <div className="customPopup__content__header">
                            <div className="customPopup__content__header__title">
                                <p className="bianco">{'Errore'}</p>
                            </div>
                            <button className="customPopup__content__header__closeButton" onClick={props.toggle}>
                                <i className="xs-font-icon bi-x-lg"></i>
                            </button>
                        </div>
                        <div className="customPopup__content__body">
                            <p>{'Non puoi aggiungere più di 15 tornei'}</p>
                        </div>
                    </div>
                </div>
            </div>
        </OverlayWrapper>
    );
}
